<template lang="pug">
	.elements-tree
		hr
		.modes
			span Editor interactivity:
			i.mode.first.fa.fa-mouse-pointer(:class="{active: Renderer.modes['select-by-click']}" v-on:click="Renderer.toggleMode('select-by-click')" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Select objects by click'}")
			i.mode.fa.fa-arrows-alt(:class="{active: Renderer.modes['move-by-drag']}" v-on:click="Renderer.toggleMode('move-by-drag')" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Move objects by drag'}")
		.scene-and-editor-types
			.screen
				span Scene:
				select.custom-select.custom-select-sm(v-on:change="")
					option(v-for="screen in screens" :selected="ScreenService.SelectedScreen?.codename === screen.codename" :value="screen.codename") {{screen.title || screen.codename}}
		.tree-holder
			.tree(:class=`{
					'sorting': !!dragProcess,
					'cloning': dragProcess && dragProcess.ctrlKey,
					'focus': isFocus
				}` v-on:mousedown="isFocus = true" v-pseudo-modal-name="'elements-tree'")
				.tree-line(v-for="(element, index) in treeList" :class=`{
						'hidden': isElementDimmed(element),
						'hit': hitElementCodename === element.codename,
						'selected': Elements.SelectedElement && Elements.SelectedElement.codename === element.codename,
						'dragged': element._dragged,
						'cloning': element._dragged && dragProcess && dragProcess.ctrlKey,
						'put-in': dragProcess && dragProcess.targetElementIndex === index && dragProcess.targetPosition === 'inside',
						'important-element': element.options && element.options.importantElement
					}` v-on:mouseover="highlightElement(element.codename)" v-on:mouseout="unhighlightElement(element.codename)")
					ElementsTreeLine(
						:element="element"
						:selectElement="selectElement"
						:openElementEffects="openElementEffects"
						:openElementEvents="openElementEvents"
						:toggleDashboardVisibility="toggleDashboardVisibility"
						:isElementHidden="isElementHidden"
						:toggleDashboardExpanded="toggleDashboardExpanded"
						:startElementsDragging="startElementsDragging"
						:dashboardExpanded="dashboardExpanded"
					)
			.drag-tree(:class=`{
					'sorting': !!dragProcess,
					'cloning': dragProcess && dragProcess.ctrlKey
				}`)(v-if="dragProcess && draggedTreeList" :style="{top: `${dragProcess.draggedStartPosition + dragProcess.draggedEndMousePosition - dragProcess.draggedStartMousePosition}px`}")
				.tree-line(v-for="element in draggedTreeList" class="dragged-over")
					ElementsTreeLine(:element="element" :dashboardExpanded="dashboardExpanded")
			.drag-place(v-if="dragProcess && draggedTreeList && (dragProcess.targetPosition === 'top' || dragProcess.targetPosition === 'bottom')" :style="{top: `${dragProcess.targetLinePosition}px`}")
		.add-new-display-object
			.dropdown-element-add(@click="openElementAddMenu($event)")
				.value Add element
				.drop-icon.fa.fa-caret-down
</template>

<script>

	import Screen 						from './../../mixins/screen'

	import { ScreenService }			from './../../services/Screen'
	import { Elements }					from './../../services/Elements'
	import { Layout }					from './../../services/Layout'
	import { Renderer }					from './../../services/Renderer'

	import ElementsTreeLine 			from './ElementsTreeLine'

	export default {
		name: 'ElementsTree',
		mixins: [Screen],
		screen: {
			updateOn: [
				"Selected Version Switched",
				"Selected Screen Switched",
				"Selected Element Switched",
				"Selected Version Element Added",
				"Selected Version Element Removed",
				"Element Changed: [parent|priority|options]",
				"Element Property Changed: [visibility]",
				"Settings Tab Changed:elements",
				"Editor Modes Changed"
			],
			events: {
				"IFrame Data:HitElement": function(data) {

					this.highlightElement(data?.screenCodename === ScreenService.SelectedScreen?.codename ? data?.elementCodename : null, false);

				},
				"IFrame Data:SelectElement": function(elementCodename) {

					this.selectElement(elementCodename, false, false);

				},
				"IFrame Data:DeleteElement": function(data) {

					this.deleteElement(data, data.elementCodename);

				},
				"Pseudo Modal Process Hide": function(els) {

					if (!_.includes(els, 'elements-tree') && this.isFocus) this.isFocus = false;

				}
			}
		},
		components: {
			ElementsTreeLine
		},
		data() {

			this.ScreenService = ScreenService;
			this.Renderer = Renderer;

			this.screens = [];

			this.treeList = [];
			this.draggedTreeList = [];

			this.dashboardExpanded = {};

			return {
				showed: true,
				treeLineHeight: 30,
				isFocus: false,
				hitElementCodename: '',

				dragProcess: null

			};

		},
		mounted() {

			window.addEventListener("mouseup", () => {

				if (this.dragProcess) this.stopElementsDragging();

			});

			window.addEventListener("mousemove", e => {

				if (this.dragProcess) this.processElementsDragging(e);

			});

			window.addEventListener("keydown", e => {

				if (_.includes(['end-cards', 'playables', 'banners', 'storyboards', 'editable-playables', 'marker'], Layout.page) && Layout.asideOpened && Layout.settingsTabName === 'elements') {

					if (e.keyCode === 46 && e.target.tagName !== 'INPUT') this.deleteElement(e);

					if (e.keyCode === 17) {

						if (this.dragProcess) {

							this.dragProcess.ctrlKey = true;

							this.update();

						}

					}

				}

			});

			window.addEventListener("keyup", e => {

				if (_.includes(['end-cards', 'playables', 'banners', 'storyboards', 'editable-playables', 'marker'], Layout.page) && Layout.asideOpened && Layout.settingsTabName === 'elements' && this.isFocus) {

					if (e.keyCode === 17) {

						if (this.dragProcess) {

							this.dragProcess.ctrlKey = false;

							this.update();

						}

					} else if (e.keyCode === 37) {

						this.changeElementNesting('left');

					} else if (e.keyCode === 39) {

						this.changeElementNesting('right');

					}

				}

			});

		},
		methods: {
			collectData() {

				if (!Version.SelectedVersion || !ScreenService.SelectedScreen) return;

				let versionScreens = ScreenService.getVersionScreens(Version.SelectedVersion);

				this.screens = _.sortBy(_.values(versionScreens), 'priority');

				this.treeList = [ {...Elements.globalElement, _offset: 0}, ...Elements.getVersionElementsTreeList(Version.SelectedVersion, ScreenService.SelectedScreen.codename, this.dashboardExpanded) ];

			},
			highlightElement(elementCodename, sendToIFrame = true) {

				// У глобального элемента нет визуального представления в превью - подсвечивать нечего
				if (elementCodename === Elements.globalElement.codename) sendToIFrame = false;

				this.hitElementCodename = elementCodename;

				//Отправляется 2 раза подряд (возможно из-за изменения css классов по наведению) - нужно исключить это через таймаут
				clearTimeout(this.HitElementTimeout);
				this.HitElementTimeout = setTimeout(() => {

					if (sendToIFrame) Broadcast.call("Send To iFrame", [{HitElement: [ScreenService.SelectedScreen.codename, elementCodename]}]);

				}, 50);

			},
			unhighlightElement(elementCodename, sendToIFrame = true) {

				if (this.hitElementCodename === elementCodename) this.hitElementCodename = '';

				//Отправляется 2 раза подряд (возможно из-за изменения css классов по наведению) - нужно исключить это через таймаут
				clearTimeout(this.HitElementTimeout);
				this.HitElementTimeout = setTimeout(() => {

					if (sendToIFrame) Broadcast.call("Send To iFrame", [{HitElement: [ScreenService.SelectedScreen.codename, '']}]);

				}, 50);

			},
			// Собственное значение свойства visibility у элемента для текущего размера (без учёта родителей)
			isElementHidden(element) {

				return element.props?.[Layout.getPreviewSizeKey()]?.visibility === 'hidden';

			},
			// Нужен ли элемент затемнить в дереве - скрыт он сам или любой из его родителей
			isElementDimmed(element) {

				let screenElements = Elements.getVersionElementsByScreen(Version.SelectedVersion)[ScreenService.SelectedScreen.codename] || {};
				let current = element;

				while (current) {
					if (this.isElementHidden(current)) return true;
					current = current.parent ? screenElements[current.parent] : null;
				}

				return false;

			},
			// Клик на иконку глаза в дереве элементов - меняет свойство visibility элемента на сервере,
			toggleDashboardVisibility(element) {

				let sizeKey = Layout.getPreviewSizeKey();

				if (this.isElementHidden(element)) {

					Server.sendToServer({
						RemoveElementProperty: {
							elementId: element.id,
							elementPropertyCodename: 'visibility',
							sizeKey
						}
					});

				} else {

					Server.sendToServer({
						SetElementProperty: {
							elementId: element.id,
							elementPropertyCodename: 'visibility',
							elementPropertyValue: 'hidden',
							sizeKey
						}
					});

				}

			},
			toggleDashboardExpanded(element) {

				let expandedKey = `${element['version_id']}-${element['screen_codename']}-${element['codename']}`;

				this.dashboardExpanded[expandedKey] = this.dashboardExpanded[expandedKey] === false;

				this.update();

			},
			selectElement(elementCodename, sendToIFrame = true, toggle = true) {

				let versionElements = Elements.getVersionElementsByScreen(Version.SelectedVersion)[ScreenService.SelectedScreen.codename];

				// Строка "world" в дереве - это ссылка на глобальный элемент
				if (elementCodename === Elements.globalElement.codename) {
					if (toggle && Elements.SelectedElement?.codename === elementCodename) Elements.selectElement(null);
					else Elements.selectElement(Elements.globalElement);
					return;
				}

				if (toggle && Elements.SelectedElement?.codename === elementCodename) {

					Elements.selectElement(null);

					if (sendToIFrame) Broadcast.call("Send To iFrame", [{SelectElement: [ScreenService.SelectedScreen.codename, null]}]);

				} else {

					Elements.selectElement(versionElements[elementCodename] || null);

					if (sendToIFrame) Broadcast.call("Send To iFrame", [{SelectElement: [ScreenService.SelectedScreen.codename, elementCodename]}]);

					//Layout.setEditorElementTab('properties');

				}

			},
			openElementEffects(elementCodename) {

				let versionElements = Elements.getVersionElementsByScreen(Version.SelectedVersion)[ScreenService.SelectedScreen.codename];

				// Строка "world" - ссылка на глобальный элемент, которого нет среди элементов экрана
				if (Elements.SelectedElement?.codename !== elementCodename) Elements.selectElement(elementCodename === Elements.globalElement.codename ? Elements.globalElement : versionElements[elementCodename] || null);

				Layout.setEditorElementTab('effects');

			},
			openElementEvents(elementCodename) {

				let versionElements = Elements.getVersionElementsByScreen(Version.SelectedVersion)[ScreenService.SelectedScreen.codename];

				// Строка "world" - ссылка на глобальный элемент, которого нет среди элементов экрана
				if (Elements.SelectedElement?.codename !== elementCodename) Elements.selectElement(elementCodename === Elements.globalElement.codename ? Elements.globalElement : versionElements[elementCodename] || null);

				Layout.setEditorElementTab('events');

			},
			startElementsDragging(element, draggedStartMousePosition, e) {
				// Сцену (root-container) и глобальный элемент (world) нельзя перетягивать
				if (['global', 'root-container'].includes(element.type)) return;

				this.dragProcess = {
					draggedElement: element,
					draggedStartPosition: 0,
					draggedStartMousePosition: draggedStartMousePosition,
					draggedEndMousePosition: 0,

					targetElementIndex: 0,
					targetElementCodename: '',
					targetPosition: '',
					targetLinePosition: 0
				};

				this.draggedTreeList = Elements.extractTreeToList([element], this.dashboardExpanded, [], element._offset);

				_.each(this.draggedTreeList, element => element._dragged = true);

				this.dragProcess.draggedStartPosition = this.treeLineHeight * _.findIndex(this.treeList, element => element.codename === this.dragProcess.draggedElement.codename);

				//this.dragProcess.draggedStartMousePosition = e.clientY;

				this.processElementsDragging(e);

			},
			processElementsDragging(e) {

				this.dragProcess.draggedEndMousePosition = e.clientY;

				if (this.dragProcess.draggedStartPosition + this.dragProcess.draggedEndMousePosition - this.dragProcess.draggedStartMousePosition < -this.treeLineHeight * 0.5) this.dragProcess.draggedEndMousePosition = -this.treeLineHeight * 0.5 + this.dragProcess.draggedStartMousePosition - this.dragProcess.draggedStartPosition;
				if (this.dragProcess.draggedStartPosition + this.dragProcess.draggedEndMousePosition - this.dragProcess.draggedStartMousePosition > this.treeList.length * this.treeLineHeight - this.treeLineHeight * 0.5) this.dragProcess.draggedEndMousePosition = this.treeList.length * this.treeLineHeight - this.treeLineHeight * 0.5 + this.dragProcess.draggedStartMousePosition - this.dragProcess.draggedStartPosition;

				let targetLinePosition = this.dragProcess.draggedStartPosition + this.dragProcess.draggedEndMousePosition - this.dragProcess.draggedStartMousePosition;

				let overIndex = Math.round(targetLinePosition / this.treeLineHeight);

				if (overIndex < 0) overIndex = 0;
				if (overIndex > this.treeList.length - 1) overIndex = this.treeList.length - 1;

				let overElement = this.treeList[overIndex];
				let overElementCodename = this.treeList[overIndex].codename;
				let overElementId = this.treeList[overIndex].id;

				let placeModifier = 'inside';
				// Над рутовым контейнером (world) - глобальный элемент, вставлять в него нельзя
				if (overElement.type === 'global') placeModifier = '';

				//Если навели на контейнер - вероятность вставки внутрь должа быть больше
				if (overElement.childs) {

					if (targetLinePosition - overIndex * this.treeLineHeight < -(this.treeLineHeight / 2) * 0.6) placeModifier = 'top';
					else if (targetLinePosition - overIndex * this.treeLineHeight > (this.treeLineHeight / 2) * 0.6) placeModifier = 'bottom';

				}

				//Если навели на НЕ контейнер - вероятность вставки внутрь должа быть меньше
				else {

					if (targetLinePosition - overIndex * this.treeLineHeight < -(this.treeLineHeight / 2) * 0.15) placeModifier = 'top';
					else if (targetLinePosition - overIndex * this.treeLineHeight > (this.treeLineHeight / 2) * 0.15) placeModifier = 'bottom';

				}

				//Если навели на элемент содержащий дочерние элементы и тип вставки bottom - нужно заменить цель на первый дочерний элемент а тип вставки top - иначе вставляет не туда куда ожидает пользователь
				if (overElement.childs && placeModifier === 'bottom') {

					overIndex++;
					overElement = overElement.childs[0];
					overElementCodename = overElement.codename;
					overElementId = overElement.id;
					placeModifier = 'top';

				}

				//Если навели на один из перемещаемых объектов - сбрасываем позицию вставки - нельзя вставлять в те объекты, которые перемещаем
				if (_.find(this.draggedTreeList, element => element.codename === overElementCodename)) placeModifier = '';

				//Если навели на объект у которого нет родителя (рутовый контейнер) - разрешается вставлять только в внутрь (inside)
				if (!overElement.parent && placeModifier !== 'inside') placeModifier = '';

				this.dragProcess.targetElementIndex = overIndex;
				this.dragProcess.targetElementCodename = overElementCodename;
				this.dragProcess.targetElementId = overElementId;
				this.dragProcess.targetPosition = placeModifier;

				this.dragProcess.targetLinePosition = (overIndex + (placeModifier === 'top' ? 0 : 1)) * this.treeLineHeight;

			},
			stopElementsDragging() {

				console.log(this.dragProcess.draggedElement.codename, '>>', this.dragProcess.targetElementCodename, '>>', this.dragProcess.targetPosition);

				if (this.dragProcess.targetPosition) {

					if (this.dragProcess.ctrlKey) {

						Server.sendToServer({
							CloneElement: {
								elementId: this.dragProcess.draggedElement.id,
								targetElementId: this.dragProcess.targetElementId,
								targetPosition: this.dragProcess.targetPosition
							}
						});

					} else {

						Server.sendToServer({
							MoveElement: {
								elementId: this.dragProcess.draggedElement.id,
								targetElementId: this.dragProcess.targetElementId,
								targetPosition: this.dragProcess.targetPosition
							}
						});

					}

				}

				this.dragProcess = null;

				_.each(this.draggedTreeList, element => delete element._dragged);

			},
			deleteElement(e) {

				if (['global', 'root-container'].includes(Elements.SelectedElement?.type)) return;
				if (!Elements.SelectedElement) return;

				Broadcast.call('Show Confirm', [{
					caption: 'Delete element',
					message: `Are you sure you want to delete element "${Elements.SelectedElement.codename}"? It will delete all child objects as well.`,
					confirmButtonText: '&nbsp;&nbsp;Delete object',
					confirmButtonIcon: 'fa-remove',
					forceConfirm: e.shiftKey,
					confirmCallback: () => {
						Server.sendToSocket({
							DeleteElement: {
								elementId: Elements.SelectedElement.id
							}
						});
					}
				}]);

			},
			changeElementNesting(direction) {

				if (['global', 'root-container'].includes(Elements.SelectedElement?.type)) return;
				if (Elements.SelectedElement) {

					Server.sendToSocket({
						ChangeElementNesting: {
							elementId: Elements.SelectedElement.id,
							direction: direction
						}
					});

				}

			},
			openElementAddMenu(e) {

				Broadcast.call("Show EditorElementAdd", [e.target.closest('.dropdown-element-add'), this.element]);

			}
		}

	}
</script>

<style lang="sass">

	.elements-tree
		user-select: none

		.scene-and-editor-types
			display: flex
			flex-direction: row
			justify-content: space-between
			padding-top: 10px

			.screen
				display: flex
				flex-direction: row
				flex-wrap: nowrap
				justify-content: left
				align-items: center
				width: 100%

				select
					margin: 0
					margin-left: 10px

		.modes
			display: flex
			flex-direction: row
			flex-wrap: nowrap
			justify-content: left
			align-items: center
			margin-top: 20px

			.mode
				display: flex
				justify-content: center
				align-items: center
				width: 20px
				height: 20px
				cursor: pointer
				margin: 3px

			.mode.first
				margin-left: 10px

			.mode.active
				color: #20a8d8

		.tree-holder
			margin: 0 -16px
			margin-top: 10px
			position: relative
			border-top: 1px solid #23282c

		.tree
			margin-top: 1px
			transition: background-color 0.2s

			&.sorting
				cursor: grabbing

		.tree.focus
			background-color: rgba(255,255,255,0.05)

		// Важные элементы (options.importantElement)
		.tree-line.important-element
			color: #d4af37

		.drag-tree
			position: absolute
			z-index: 2
			left: 0
			top: 0
			width: calc(100% + 30px)
			//background: #4b545e
			border-top: 1px solid #343a42
			opacity: 0.8

		.drag-place
			position: absolute
			pointer-events: none
			z-index: 1
			left: 0
			top: 0
			width: calc(100% + 30px)
			height: 3px
			background: #272c32
			border-top: 1px solid #272c32
			border-bottom: 1px solid #272c32
			margin-top: -1px

		.add-new-display-object
			display: flex
			align-items: center
			justify-content: left
			flex-direction: row
			white-space: nowrap
			margin-top: 20px

			.dropdown-element-add
				position: relative
				border: 1px solid rgba(255, 255, 255, 0.1)
				border-radius: 0.25rem
				background: rgba(255, 255, 255, 0.05) no-repeat
				background-position-x: right 0.75rem
				background-position-y: calc(50% - 1px)
				background-size: 8px 10px
				padding-top: 0.25rem
				padding-bottom: 0.25rem
				padding-right: 2rem
				padding-left: 0.5rem
				color: rgba(255, 255, 255, 0.5)
				cursor: pointer
				font-size: 0.765625rem

				&:hover
					border: 1px solid rgba(255, 255, 255, 0.3)
					background: rgba(255, 255, 255, 0.1) no-repeat

				.value
					max-width: 125px
					overflow: hidden
					text-overflow: ellipsis
					white-space: nowrap

				.drop-icon
					position: absolute
					right: 13px
					top: 8px
					color: rgba(255, 255, 255, 0.50)

</style>
